import Type from '../Redux/Constants'

export const setUserDetails = data => ({
    type: Type.EMPLOYEE_DETAILS,
    payload: data,
  });
  export const setEmployeeAuth = data => ({
    type: Type.EMPLOYEE_AUTH,
    payload: data,
  });
  export const setEmployeeLeaveDetails = data => ({
    type: Type.EMPLOYEE_LEAVE_DETAIL,
    payload: data,
  });
  export const setEmployeeAllDetails = data => ({
    type: Type.EMPLOYEE_ALL_DETAILS,
    payload: data,
  });
  export const setEmployeeindex = data => ({
    type: Type.EMPLOYEE_SELECTED_INDEX,
    payload: data,
  });
  export const setEmployeeHoliday = data => ({
    type: Type.EMPLOYEE_HOLIDAY,
    payload: data,
  });